/* tslint:disable */
/* eslint-disable */
/**
 * People Rock Platform API
 * REST API for the People Rock Platform - An AI-powered competency development platform.  ## Features - User authentication and authorization (JWT) - Role-based access control (ADMIN, TRAINER, PARTICIPANT) - User management - Internationalization support (Portuguese, English) - Locale management  ## Authentication Most endpoints require JWT authentication. To authenticate: 1. Register a new account: POST /auth/register 2. Or login with existing credentials: POST /auth/login 3. Copy the JWT token from the response 4. Click \"Authorize\" button above and enter: Bearer {token} 5. All subsequent requests will include the authorization header  ## Localization The API supports Portuguese (default) and English. Set the Accept-Language header: - `Accept-Language: pt` for Portuguese - `Accept-Language: en` for English  ## Rate Limiting - `POST /api/auth/login`: 10 requests per minute per IP - `POST /api/auth/register`: 5 requests per hour per IP - Other endpoints are not rate limited by the API  ## Support For API support, contact the development team via the contact information below. 
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * Contact: dev@peoplerock.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { DevelopmentAreaResponse } from '../models';
/**
 * DevelopmentAreasApi - axios parameter creator
 * @export
 */
export const DevelopmentAreasApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary List active development areas with their active dimensions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveAreas: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/development-areas`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * DevelopmentAreasApi - functional programming interface
 * @export
 */
export const DevelopmentAreasApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = DevelopmentAreasApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary List active development areas with their active dimensions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getActiveAreas(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<DevelopmentAreaResponse>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getActiveAreas(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['DevelopmentAreasApi.getActiveAreas']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * DevelopmentAreasApi - factory interface
 * @export
 */
export const DevelopmentAreasApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = DevelopmentAreasApiFp(configuration)
    return {
        /**
         * 
         * @summary List active development areas with their active dimensions
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getActiveAreas(options?: RawAxiosRequestConfig): AxiosPromise<Array<DevelopmentAreaResponse>> {
            return localVarFp.getActiveAreas(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * DevelopmentAreasApi - object-oriented interface
 * @export
 * @class DevelopmentAreasApi
 * @extends {BaseAPI}
 */
export class DevelopmentAreasApi extends BaseAPI {
    /**
     * 
     * @summary List active development areas with their active dimensions
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof DevelopmentAreasApi
     */
    public getActiveAreas(options?: RawAxiosRequestConfig) {
        return DevelopmentAreasApiFp(this.configuration).getActiveAreas(options).then((request) => request(this.axios, this.basePath));
    }
}

